<template>
  <div class="ml-5 mr-5">
    <div class="text-right my-4">
      <loading :active.sync="isLoading" :can-cancel="false" loader="dots" color="#007bff" :height="45" :width="75"
        :is-full-page="fullPage"></loading>
      <template>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn small class="mx-2" color="secondary" dark @click="openArchiveDialog">
              Archive
            </v-btn>
            <v-btn small class="mx-2" color="primary" dark v-bind="attrs" v-on="on"
              v-show="checkIfOperationExistForModule('add')">
              Add
            </v-btn>


          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Add Media Channel</span>
            </v-card-title>
            <v-form ref="addMchannelForm" @submit="addMchannelData" method="post" v-model="valid" lazy-validation>
              <v-container class="px-50" fluid>
                <v-text-field v-model="addMchannel.mChannelName" label="Media Channel Name" :rules="nameRules"
                  required></v-text-field>
                <div style="color: red">
                  {{ message1 }}
                </div>
              </v-container>
              <v-container class="px-50" fluid> </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" type="submit" @click="validate">
                  Submit
                </v-btn>
                <v-btn class="close_button mx-2" text @click="reset"> Close </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog max-width="600" v-model="dialog2">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small color="error" v-bind="attrs" v-on="on" v-show="checkIfOperationExistForModule('delete')">Soft
            Delete</v-btn>
        </template>
        <div v-if="deleteItems.length > 0">
          <template>
            <v-card>
              <v-card-text>
                <div class="text-h3 pa-12">
                  Are you sure you want to delete all the selected Record(s)
                </div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-form ref="form" method="post">
                  <v-btn text class="confirm_button mx-2" v-on:click="dialog2 = false"
                    @click="deleteMailType">Yes</v-btn>
                </v-form>
                <v-btn class="close_button mx-2" text @click="dialog2 = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </div>
        <div v-if="deleteItems.length == 0">
          <template>
            <v-card>
              <v-card-text class="center">
                <div class="text-h3 pa-12">
                  Please Select Record(s) to delete
                </div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn class="close_button mx-2" text @click="dialog2 = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </div>
      </v-dialog>

      <v-dialog v-model="archiveDialog" max-width="650px">
        <v-card>

          <!-- Title -->
          <v-card-title class="justify-center">
            <span class="headline">Archived Media Channels</span>
          </v-card-title>

          <!-- Action Buttons -->
          <div class="px-6 pb-2 mt-5" v-if="isAdmin">
            <v-row no-gutters class="align-center">
              <v-col cols="12" class="text-right">
                <v-btn small color="error" class="mr-2" @click="deleteArchivePermanently">
                  Delete
                </v-btn>
                <v-btn small color="primary" @click="restoreArchive">
                  Restore
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <!-- Table -->
          <v-data-table :headers="archiveHeaders" :items="archiveList" item-key="mChannel_id" dense hide-default-footer
            show-select v-model="selectedArchiveItems">
            <!-- No custom checkbox column needed -->
          </v-data-table>

          <!-- Optional message when empty -->
          <div v-if="archiveList.length === 0" class="text-center grey--text py-4">
            No archived records found
          </div>

          <!-- Actions -->
          <v-card-actions class="justify-end">
            <v-btn text @click="archiveDialog = false">Close</v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>


    </div>
    <div class="text-right"></div>

    <!-- v-data-table  -->
    <v-row>
      <v-col cols="12">
        <div class="tableWrapper">
          <div id="select-all-checkbox">
            <v-checkbox ref="n" v-model="allSelected" @click="selectAll"
              v-show="checkIfOperationExistForModule('delete')"></v-checkbox>
          </div>
          <v-data-table :headers="headers" item-key="product_id" :items="mChannel_data" :options.sync="options"
            :server-items-length="total" :loading="isLoading" class="elevation-1" hide-default-footer>
            <template v-slot:item.selectCheckbox="{ item }">
              <v-checkbox ref="n" v-model="deleteItems" :value="item.mChannel_id" :key="item.mChannel_id"
                @click="addToDelete($event, item.mChannel_id)"
                v-show="checkIfOperationExistForModule('delete')"></v-checkbox>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon medium color="grey" @click="addToUpdate($event, item.mChannel_id)"
                v-show="checkIfOperationExistForModule('edit')">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="toggleUpdateModal" max-width="600">
        <template>
          <v-card>
            <v-card-title>
              <span class="headline">Update Media Channel</span>
            </v-card-title>
            <v-form ref="form" @submit="updateMchannelData" method="put">
              <v-container class="px-50" fluid>
                <v-text-field v-model="updateMchannel.mChannelName" label="Media Channel Name*" required
                  :rules="nameRules"></v-text-field>
                <div style="color: red">
                  {{ upmessage1 }}
                </div>
              </v-container>
              <v-container class="px-50" fluid> </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" @click="updateMchannelData" type="submit">
                  Update
                </v-btn>
                <v-btn class="close_button mx-2" text @click="toggleUpdateModal = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </template>
      </v-dialog>
    </v-row>
    <!-- v-data-table-ends -->
  </div>
</template>

<script>
import axios from "axios";
import Index from "./Index.vue";
import VueCookies from "vue-cookies";

import Buttons from "./component/Buttons.vue";
import Item from "../../components/base/Item.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: { Index, Buttons, Loading },
  data() {
    return {
      toggleUpdateModal: false,
      //////table data starts here////
      archiveDialog: false,
      archiveList: [],               // store archived items
      selectedArchiveItems: [],      // store selected items in archive
      isAdmin: false,
      archiveHeaders: [
        { text: "", value: "select", width: "50px", sortable: false },
        { text: "Media name", value: "mChannel_name", sortable: false },
      ],

      selected: [],
      options: {},
      sort: "",
      total: 0,
      editReportMode: false,
      fromDateMenu: false,
      fromDateVal: null,
      //  minDate: "2020-01-05",
      //  maxDate: "2019-08-30",
      headers: [
        {
          text: "",
          value: "selectCheckbox",
          width: "50px",
          sortable: false,
          class: "v-data-table-header",
        },
        {
          text: "Media name",
          value: "mChannel_name",
          width: "200px",
          sortable: false,
          class: "v-data-table-header",
        },
        {
          text: "Action",
          value: "actions",
          width: "150px",
          sortable: false,
          class: "v-data-table-header",
        },
      ],
      ////// table data ends here
      valid: true,
      checkbox: false,
      isLoading: true,
      fullPage: true,
      mChannelName: [],
      mChannel_data: [],
      checkbox1: false,
      dialog: false,
      dialog1: false,
      dialog2: false,
      deleteItems: [],
      checked_mChannelId: [],
      checkcedstr: "",
      message1: "",
      message2: "",
      upmessage1: "",
      upmessage2: "",
      allSelected: false,
      addMchannel: {
        mChannelName: null,
      },
      updateMchannel: {
        mChannelId: null,
        mChannelName: null,
      },
      checked: false,
      nameRules: [(v) => !!v || "Name is required"],
    };
  },
  methods: {
    checkIfOperationExistForModule(type) {
      return this.$utils.checkIfOperationExistForModule(this, type)
    },
    validate() {
      this.$refs.form.validate();
    },
    openArchiveDialog() {
      this.archiveDialog = true;
      this.getArchivedMchannels();
    },
    getArchivedMchannels() {
      let view = this;
      const path = this.$url("MCHANNEL");

      view.isLoading = true;

      this.$fetch({ requiresAuth: true, operation: 'view', vueScope: view })
        .get(path, {
          params: {
            is_deleted: true
          }
        })
        .then((res) => {
          view.isLoading = false;

          const data = res.data.payload.mChannelID || [];

          this.archiveList = data.map(item => ({
            mChannel_id: item[0],
            mChannel_name: item[1]
          }));
        })
        .catch((error) => {
          view.isLoading = false;
          console.error(error);
        });
    },
    restoreArchive() {
      if (this.selectedArchiveItems.length === 0) {
        this.$swal.fire("Select record(s) to restore");
        return;
      }

      let view = this;
      this.isLoading = true;
      const idsArray = this.selectedArchiveItems.map(
        item => Number(item.mChannel_id)
      );

      console.log("Sending IDs:", idsArray);

      this.$fetch({ requiresAuth: true, operation: 'edit', vueScope: view })
        .post(this.$url("RESTORE_MCHANNEL"), {
          ids: idsArray
        })
        .then((response) => {
          view.isLoading = false;

          if (response.data.statusCode === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Record(s) restored successfully",
              text: response.data.payload.message,
            });

            this.getMchannel();
            this.getArchivedMchannels();
            this.selectedArchiveItems = [];
            this.archiveDialog = false;
          }
        })
        .catch((error) => {
          view.isLoading = false;
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Restore failed",
            text: "Something went wrong!",
          });
        });
    },


    deleteArchivePermanently() {
      if (this.selectedArchiveItems.length === 0) {
        this.$swal.fire("Select record(s) to delete");
        return;
      }

      let view = this;
      this.isLoading = true;
 const ids = this.selectedArchiveItems.map(
        item => Number(item.mChannel_id)
      );
      this.$fetch({ requiresAuth: true, operation: 'delete', vueScope: view })
        .delete(this.$url("MCHANNEL"), {
          params: {
            id: ids,
            soft: false
          }
        })
        .then((response) => {
          view.isLoading = false;

          if (response.data.statusCode === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Record(s) deleted permanently",
              text: response.data.payload.message,
            });
             this.archiveDialog = false;
          }

          this.getMchannel();
          this.getArchivedMchannels();

          this.selectedArchiveItems = [];
        })
        .catch((error) => {
          console.error(error);
          view.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
          });
        });
    },


    reset() {
      this.dialog = false;
      this.dialog1 = false;
      this.message1 = "";
      this.upmessage1 = "";
      if (this.$refs.addMchannelForm) {
        this.$refs.addMchannelForm.resetValidation();
        this.$refs.addMchannelForm.reset();
      }
      // If you want to reset the update form as well, you can add:
      // if (this.$refs.form) {
      //   this.$refs.form.resetValidation();
      //   this.$refs.form.reset();
      // }
    },
    getMchannel() {
      const path = this.$url("MCHANNEL");
      this.isLoading = true;
      this.$fetch({ requiresAuth: true, operation: 'view', vueScope: this })
        .get(path)
        .then((res) => {
          this.isLoading = false;
          this.mChannelName = res.data.payload;
          this.total = this.mChannelName.length;
          if (Array.isArray(this.mChannelName) && this.mChannelName.length) {
            this.mChannel_data = [];
            let i;
            for (i = 0; i < this.mChannelName.length; i++) {
              let tempobj = {
                mChannel_id: this.mChannelName[i][0],
                mChannel_name: this.mChannelName[i][1],
              };
              this.mChannel_data.push(tempobj);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    addMchannelData(e) {
      e.preventDefault();
      let view = this;
      // Validate the form before proceeding
      if (!this.$refs.addMchannelForm.validate()) {
        view.isLoading = false;
        return;
      }
      this.isLoading = true;
      if (
        this.addMchannel.mChannelName != null &&
        this.addMchannel.mChannelName != ""
      ) {
        this.$fetch({ requiresAuth: true, operation: 'add', vueScope: view })
          .post(this.$url("MCHANNEL"), this.addMchannel)
          .then((result) => {
            view.isLoading = false;
            this.addMchannel.mChannelName = "";
            if (result.data.statusCode == 200) {
              this.getMchannel();
              this.reset();
            } else {
              let payload = result.data.payload;
              let message = (payload && payload.message) ? payload.message : "Something went wrong!";
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: message,
              });
            }
          }).catch((error) => {
            console.error(error);
            view.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong!",
            });
          });
      }
    },
    addToUpdate(e, atchid) {
      let view = this;
      this.toggleUpdateModal = true
      view.mChannelName.forEach(function (o, i) {
        if (o[0] == atchid) {
          view.updateMchannel.mChannelName = o[1];
          view.updateMchannel.mChannelId = o[0];
        }
      });
    },
    updateMchannelData(e) {
      e.preventDefault();
      let data = this;
      this.isLoading = true
      if (
        data.updateMchannel.mChannelName != null &&
        data.updateMchannel.mChannelName != ""
      ) {
        this.$fetch({ requiresAuth: true, operation: 'edit', vueScope: data })
          .put(data.$url("MCHANNEL"), data.updateMchannel)
          .then((result) => {
            data.isLoading = false
            console.log(result);
            this.upmessage1 = result.data.payload.mChannelID;
            this.upmessage2 = result.data.payload.mChannelName;
            if (this.upmessage2 == null) {
              this.upmessage1 = result.data.payload.mChannelID;
              this.dialog1 = true;
            } else {
              this.upmessage1 = null;
              this.dialog1 = false;
              if (result.data.statusCode == 200 && this.upmessage1 == null) {
                this.getMchannel();
                this.$swal.fire({
                  icon: "success",
                  title: "Record(s) updated successfully",
                  text: result.data.payload.message,
                });
                this.toggleUpdateModal = false
              }
              this.reset();
            }
            console.log(result);
          }).catch((error) => {
            console.error(error);
            data.isLoading = false
            data.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong!",
            });
          });
      }
    },
    addToDelete(e, atchid) {
      this.checkedthis = false;
      //e.target.checked
      if (e.target.checked) {
        if (this.checked_mChannelId.indexOf(e.target.value) == -1) {
          this.checked_mChannelId.push(e.target.value);
        }
      } else {
        this.checked_mChannelId.splice(
          this.checked_mChannelId.indexOf(e.target.value),
          1
        );
      }
      let checkcedstr = this.checked_mChannelId.join(",");
      this.checkcedstr = checkcedstr;
      // console.log(this.checkcedstr);
    },
    deleteMailType(e) {
      e.preventDefault();
      let view = this;
      this.isLoading = true
      console.log(this.deleteItems);
      this.$fetch({ requiresAuth: true, operation: 'delete', vueScope: view })
        .delete(this.$url("MCHANNEL"), {
          params: {
            id: this.deleteItems,
            soft: true
          }
        })
        .then((response) => {
          view.isLoading = false
          if (response.data.statusCode == 200) {
            this.$swal.fire({
              icon: "success",
              title: "Selected record(s) has been deleted",
              text: response.data.payload.message,
            });
          }
          this.getMchannel();
          this.deleteItems = [];
        }).catch((error) => {
          console.error(error);
          view.isLoading = false
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Something went wrong!",
          });
        });
    },
    selectAll: function () {
      let mChannel = this.mChannelName;
      if (this.allSelected == true) {
        if (Array.isArray(mChannel) && mChannel.length) {
          this.deleteItems = [];
          let i;
          for (i = 0; i < mChannel.length; i++) {
            console.log(mChannel[i]);
            this.deleteItems.push(mChannel[i][0]);
          }
        }
      } else if (this.allSelected == false) {
        this.deleteItems = [];
      }
    },
    select: function () {
      this.allSelected = false;
    },
    submit() {
      this.$v.$touch();
    },
  },
  created() {
    const userRole = VueCookies.get("user_role");
    this.isAdmin = Number(userRole) === 1;
  },

  watch: {
    '$store.state.Rawdata.current_active_module': function (o) {
      if (o) {
        this.getMchannel(1);
      }
    },
  },
};
</script>
<style scoped>
.v-dialog .v-card {
  overflow: hidden !important;
}

.v-data-table {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}
</style>
